module.exports = __webpack_public_path__ + "static/media/error_outline-24px.0f26d54c.svg";